import React, { useEffect, useRef } from 'react';
import lottie from 'lottie-web';
import animationData from './Animation - 1715857244942.json';

const LottieAnimation = () => {
  const container = useRef(null);

  useEffect(() => {
    const anim = lottie.loadAnimation({
      container: container.current,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      animationData: animationData,
    });

    return () => anim.destroy();
  }, []);

  return <div ref={container} style={{ width: '50%', height: '50%' }} />;
};

export default LottieAnimation;
